function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  d: "M42 0h15v48H42zM0 0h15v74H0z",
  fill: "currentColor"
}), React.createElement("path", {
  d: "M226 74L201.236 0H185l24.764 74zM156.236 74L181 0h-16.247L140 74z",
  fill: "#00a7e1"
}), React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M124.236 74L149 0h-16.236L108 74zM104 74L79.236 0H63l24.764 74z"
})));

var SvgLogo = function SvgLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 226 74"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjI2IDc0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9Im5vbmUiPjxwYXRoIGQ9Im00MiAwaDE1djQ4aC0xNXoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGQ9Im0wIDBoMTV2NzRoLTE1eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0ibTIyNiA3NC0yNC43NjQwOTItNzRoLTE2LjIzNTkwOGwyNC43NjQwOTIgNzR6IiBmaWxsPSIjMDBhN2UxIi8+PHBhdGggZD0ibTE1Ni4yMzU5MDggNzQgMjQuNzY0MDkyLTc0aC0xNi4yNDc0NjNsLTI0Ljc1MjUzNyA3NHoiIGZpbGw9IiMwMGE3ZTEiLz48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Im0xMjQuMjM1OTA4IDc0IDI0Ljc2NDA5Mi03NGgtMTYuMjM1OTA4bC0yNC43NjQwOTIgNzR6Ii8+PHBhdGggZD0ibTEwNCA3NC0yNC43NjQwOTI0LTc0aC0xNi4yMzU5MDc2bDI0Ljc2NDA5MjQgNzR6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgLogo as ReactComponent };